import BasePage from "@Scripts/Pages/BasePage";

export default class ProductDetailPage extends BasePage {
    public static async init() {
        await super.init();

        this.setReadButtonBox();

        this.setModal();
    }

    private static setReadButtonBox() {
        let readButton = document.getElementById("ReadButton"),
            productDetailBox = document.getElementById("ProductDetailBox"),
            contentEditorBox = document.getElementById("ContentEditorBox"),
            readButtonBox = document.getElementById("ReadButtonBox"),
            windowWidth = window.innerWidth,
            height = 0;

        if (windowWidth) {
            if (windowWidth < 750) {
                height = 1130;
            } else if (windowWidth < 1366) {
                height = 750;
            } else {
                height = 780;
            }
        }

        if (contentEditorBox) {
            if (contentEditorBox.clientHeight >= height) {
                if (readButtonBox) {
                    if (readButtonBox.classList.contains("hden")) {
                        readButtonBox.classList.remove("hden");
                    }
                }

                if (readButton) {
                    readButton.addEventListener("click", function () {
                        if (productDetailBox) {
                            productDetailBox.classList.add("show");
                        }
                    });
                }
            } else {
                if (readButtonBox) {
                    if (!readButtonBox.classList.contains("hden")) {
                        readButtonBox.classList.add("hden");
                    }
                }
            }
        }
    }

    private static setModal() {
        let productRequest = document.getElementById("ProductRequest");
        if (productRequest) {
            (<any>window).lightGallery(productRequest, {
                selector: "this",
                download: false,
                counter: false
            });
        }
    }
}